import { useCallback, useRef, useState, useEffect } from 'react';
import moment from 'moment-timezone';
import Calendar from 'react-calendar';

import useClickOutside from '../../../../hooks/useClickOutside';
import { ChevronDownIcon } from '../../../../assets/svg/iconos';
import { useDispatch } from 'react-redux';
import { openModalBottom } from '../../../../actions/ui';

const timezone = process.env.REACT_APP_TIMEZONE;

export const SelectBirthdate = ({objPromocion, dataChange, editMode}) => {

    const dispatch = useDispatch();
    const [dateClicked, setDateClicked] = useState( false );
    const [selectText, setSelectText] = useState('');
    const [fechaCalendar, setFechaCalendar] = useState( new Date() );

    const popover = useRef();
    const [isOpen, toggle] = useState(false);
    

    const close = useCallback(() => toggle(false), []);
    useClickOutside(popover, close);

    const clickSelect = () => {
        toggle( !isOpen );
    }

    useEffect(() => {
      if( objPromocion?.fechaNac ){
        if( moment.utc( objPromocion?.fechaNac ).format('DD-MM-YYYY') === '31-12-3100' ){
            setSelectText( 'Todas' );
        } else {
            setSelectText( moment.tz( objPromocion?.fechaNac, timezone ).format('D/M/YYYY') );
            setDateClicked( true );
            setFechaCalendar( moment.tz(objPromocion?.fechaNac, timezone).toDate() );
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [objPromocion]);

    const dayClicked = () => {
        /* setTimeCalendar(new Date(1972,10,13,0,0));
        (visibility) ? hideDropdown() : showDropdown() */
    };

    const dateChange = (e) => {
        if( editMode ){
            setFechaCalendar( e );
            const stringDate = `${moment(e).format('YYYY-MM-DD')} 23:59:59`;
            setSelectText( moment.tz( stringDate, timezone ).format('D/M/YYYY') );
            dataChange( 'fechaNac', moment.tz( stringDate, timezone ).toISOString() );
        } else {
            dispatch( openModalBottom({text: ['Debes desactivar la casilla "Todas" del calendario para poder establecer una fecha concreta.'], timeOut: 3}) );
        }
    };

    const radioClicked = ( option ) => {
        if( editMode ){
            console.log( 'radioClicked' );
            if( option === 'todas' ){
                dataChange( 'fechaNac', moment.utc('3100-12-31 23:59:59').toISOString() );
                setDateClicked( false );
                setSelectText( 'Nunca' );
                setFechaCalendar( new Date() );
            } else {
                dataChange( 'fechaNac', moment().tz( timezone ).toISOString() );
                setFechaCalendar( moment().tz( timezone ).toDate() );
                setSelectText( moment.tz( fechaCalendar, timezone ).format('D/M/YYYY') );
                setDateClicked( true );
            }
        } else {
            dispatch( openModalBottom({text: ['Debes activar la edición para poder realizar cambios'], timeOut: 3}) );
        }
    }

    return (
        <div 
            className='ylm-caducidad-select promocion-selector'
        >
            <div 
                className='select-main'
                onClick={ clickSelect }
            >
                <p>{ selectText }</p>
                <div 
                    className='btn-chevron'
                    style={{ transform: isOpen && 'rotate(180deg)'}}
                >
                    <ChevronDownIcon
                        color={ '#000000' }
                    />
                </div>
            </div>
            {
                isOpen &&
                <ul 
                    className='select-options calendario' 
                    ref={popover}
                >
                    <li className={`with-calendar`}>
                        <div className={`descuento-select-date`}>
                            <Calendar
                                onClickDay={ () => dayClicked() }
                                onChange={ dateChange }
                                value={ fechaCalendar }
                                locale={`es-ES`}
                            />
                            <div className='nunca'>
                                <div 
                                    className='nunca-check'
                                    onClick={ () => radioClicked(`${dateClicked ? 'todas' : 'fecha'}`) }
                                >
                                    <div 
                                        className='checkbox-bg'
                                    >
                                        {
                                            !dateClicked &&
                                            <span 
                                                className='checkbox-item'
                                            ></span>
                                        }
                                    </div>
                                    <p>{ `Todas` }</p>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            }
        </div>
    )
}
